<template>
  <div class="strategy-organize">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <div class="page-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
            <div class="solution-btn" @click="openBealter">预约演示</div>
          </div>
        </div>
      </div>
      <div ref="nav" class="page-nav">
        <div ref="navTabs" class="page-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['page-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div ref="product-value" class="product-value">
        <div class="title">产品价值分析</div>
        <div class="product-value-content">
          <img :src="productValue" alt="" />
        </div>
      </div>
      <div>
        <div id="architecture" ref="architecture" class="architecture">
          <div class="title">系统流程图</div>
          <div class="flow-chart-content">
            <img :src="architecture" alt="" />
          </div>
        </div>
      </div>
      <div>
        <div ref="introduction" class="introduction">
          <div class="title">系统功能介绍</div>
          <div class="introduction-tag-list">
            <div
              v-for="(item, index) in introductionTagList"
              :key="index"
              class="tag-list-item"
              :class="{'tag-list-item-change': introductionIndex == index}"
            >
              <div class="tag-list-text" @click="changeStep(item)">
                {{ item.text }}
              </div>
            </div>
          </div>
          <div class="introduction-content-box">
            <div v-if="introductionList.length > 0" :key="introductionIndex" class="introduction-content">
              <div class="introduction-content-left">
                <div class="content-title-wrap">
                  <div class="list"></div>
                  <div class="content-title">
                    {{ introductionList[introductionIndex].title }}
                  </div>
                </div>
                <div class="content-describe">{{ introductionList[introductionIndex].describe }}</div>
                <div
                  v-for="(item, index) in introductionList[introductionIndex].content"
                  :key="index"
                  class="content-text-box"
                >
                  <img :src="require('@/assets/staffmanage/icon/liIcon.png')" alt="" class="content-icon" />
                  <div class="content-text">{{ item }}</div>
                </div>
              </div>
              <div class="introduction-content-right">
                <img :src="introductionList[introductionIndex].img" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="data-security" class="data-security">
          <div class="data-security-wrap">
            <div class="data-security-title">了解更多有关华跃产品与服务信息</div>
            <div class="data-security-subtitle">您还可以预约我们的产品演示</div>
            <div class="data-security-btn" @click="openBealter">
              <div class="btn-text" @click="openBealter">
                预约产品演示
              </div>
            </div>
          </div>
          <div class="data-security-list">
            <div
              v-for="(item, index) in dataSecurityList"
              :key="index"
              class="data-security-item"
            >
              <div class="item-icon-wrap">
                <img :src="item.icon" alt="" />
              </div>
              <div class="item-content-wrap">
                <div class="item-content-title">{{ item.title }}</div>
                <div
                  v-for="(textItem, textIndex) in item.textList"
                  :key="textIndex"
                  class="item-content-text"
                >
                  <div class="textItem-li"></div>
                  <div class="textItem">
                    {{ textItem }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="customer-stories">
          <div style="width: 100%; height: 60px; background-color: #f7f9fc;"></div>
          <div class="customer-stories">
            <div class="customer-stories-content">
              <div class="title">中大型企业的共同选择</div>
              <div class="customer-stories-list">
                <div v-for="(item, index) in enterpriseList" :key="index" class="cystiner-stirues-item">
                  <img :src="item" alt="" />
                </div>
              </div>
              <div class="customer-stories-btn" @click="moreEnterprise">
                <div class="btn-text">
                  查看更多案例
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="data-download" class="data-download-wrap">
        <div class="data-download">
          <div class="title">行业资料</div>
          <div class="data-download-content">
            <div v-for="(item, index) in dataDownloadList" :key="index" class="data-download-content-item">
              <div class="dataListTitle">{{ item.title }}</div>
              <ul class="data-list">
                <li
                  v-for="(dataItem, dataIndex) in item.dataList"
                  :key="dataIndex"
                  class="data-list-item"
                  @click="clickDate(dataItem, index)"
                >
                  <div class="data-list-left">
                    <div class="data-title">
                      {{ dataItem.title }}
                    </div>
                  </div>
                  <div class="data-list-right">
                    <img :src="require('@/assets/icon/right-arrow.png')" alt="" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail, download } from '@/api/content';
// import stories1 from '@/assets/staffmanage/stories1.png';
// import stories2 from '@/assets/staffmanage/stories2.png';
// import stories3 from '@/assets/staffmanage/stories3.png';
// import stories4 from '@/assets/staffmanage/stories4.png';
// import stories5 from '@/assets/staffmanage/stories5.png';
// import stories6 from '@/assets/staffmanage/stories6.png';
// import stories7 from '@/assets/staffmanage/stories7.png';
export default {
  name: 'StrategyOrganize',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/strategy/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      valueIndex: null,
      topNaviId: null,
      navList: [
        {
          title: '产品价值',
          id: 'product-value',
        },
        {
          title: '系统架构',
          id: 'architecture',
        },
        {
          title: '功能介绍',
          id: 'introduction',
        },
        {
          title: '数据安全',
          id: 'data-security',
        },
        {
          title: '客户案例',
          id: 'customer-stories',
        },
        {
          title: '资料下载',
          id: 'data-download',
        },
      ],
      productValue: '',
      architecture: '',
      introductionTagList: [
        // {
        //   text: '基础组织',
        //   index: 0,
        // },
      ],
      introductionIndex: 0,
      introductionList: [
        // {
        //   title: '基础组织',
        //   describe: '组织架构复杂，调整频繁，无法实时呈现架构图',
        //   img: require('@/assets/strategy/introduction1.png'),
        //   content: [
        //     '系统架构图与组织架构联动，在进行架构调整的时候，架构图也实时更新。',
        //     '实现多组织并存的形式，满足集团化多元化业务场景的要求。',
        //     '自动封存变更节点，记录架构变更前后的信息对比',
        //   ],
        // },
      ],
      dataDownloadList: [
        {
          title: '资料下载',
          dataList: [],
        },
        {
          title: '产品动态',
          dataList: [],
        },
        {
          title: '干货推荐',
          dataList: [],
        },
      ],
      enterpriseList: [
      ],
      dataSecurityList: [],
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            // var elementTop = document.querySelector('#' + this.navList[i].id).offsetTop - this.scrollTop - 1;
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
    this.getPartner();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = (offsetHeight / 2) + 70 + 'px';
      }
    },

    // 获取页面栏目
    getPageColumn() {
      const params = { parentId: '1605128867625000960', };
      getColumnChild(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '产品价值') {
            getColumnDetail(result[i].id).then((rrs) => {
              this.productValue = rrs.result.icon;
            });
          } else if (result[i].name === '系统架构') {
            getColumnDetail(result[i].id).then((rrs) => {
              this.architecture = rrs.result.icon;
            });
          } else if (result[i].name === '功能介绍') {
            getContentList({ columnId: result[i].id, pageNum: 1, pageSize: 99, }).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var TagItem = {
                  text: rrsult.data[j].title,
                  index: j,
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                var introductionItem = {
                  title: '',
                  describe: '',
                  img: '',
                  content: [],
                };
                const rtsult = rts.result;
                introductionItem.title = rtsult.title;
                introductionItem.describe = rtsult.summaryTitle;
                introductionItem.img = rtsult.icon;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  introductionItem.content.push(rtsult.elements[x].content);
                }
                this.introductionList.push(introductionItem);
                this.introductionTagList.push(TagItem);
              }
            });
          } else if (result[i].name === '数据安全') {
            getContentList({ columnId: result[i].id, pageNum: 1, pageSize: 99, }).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                var dataSecurityItem = {
                  title: '',
                  icon: '',
                  textList: [],
                };
                const rtsult = rts.result;
                dataSecurityItem.title = rtsult.title;
                dataSecurityItem.icon = rtsult.icon;
                for (var x = 0; x < rtsult.elements.length; x++) {
                  dataSecurityItem.textList.push(rtsult.elements[x].content);
                }
                this.dataSecurityList.push(dataSecurityItem);
                // getContentDetail(rrsult.data[j].id).then((rts) => {
                // });
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
      const downLoadParams = { columnId: '1605494229646401536', pageNum: 1, pageSize: 4, commendation: 8, cascade: true, };
      getContentList(downLoadParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[0].dataList = result.data;
      });
      const contentParams = { columnId: '1605774350588534784', pageNum: 1, pageSize: 4, commendation: 8, };
      getContentList(contentParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[1].dataList = result.data;
      });
      const industryParams = { columnId: '1605774444985540608', pageNum: 1, pageSize: 4, commendation: 8, };
      getContentList(industryParams).then(async (res) => {
        const { result, } = res;
        this.dataDownloadList[2].dataList = result.data;
      });
    },

    // 合作伙伴列表
    getPartner() {
      var params = { columnId: '1605405080163672064', pageNum: 1, pageSize: 18, commendation: 16, cascade: true, };
      getContentList(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.data.length; i++) {
          this.enterpriseList.push(result.data[i].logo);
        }
      });
    },

    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    clickDate(data, index) {
      if (index === 0) {
        getContentDetail(data.id).then((res) => {
          const { result, } = res;
          var file = result.elements.find(obj => obj.name === 'file').content;
          download(file[0].url).then((rrs) => {
            const fileName = file[0].name;
            const blob = new Blob([ rrs.data, ]);
            if (typeof window.navigator.msSaveBlob !== 'undefined') {
              // 兼容window.navigator.msSaveBlob：以本地方式保存文件
              window.navigator.msSaveBlob(blob, decodeURI(fileName));
            } else {
              // 创建新的URL并指向File对象或者Blob对象的地址
              const blobURL = window.URL.createObjectURL(blob);
              // 创建a标签，用于跳转至下载链接
              const tempLink = document.createElement('a');
              tempLink.style.display = 'block';
              tempLink.href = blobURL;
              tempLink.setAttribute('download', decodeURI(fileName));
              // 兼容：某些浏览器不支持HTML5的download属性
              if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank');
              }
              // 挂载a标签
              document.body.appendChild(tempLink);
              tempLink.click();
              document.body.removeChild(tempLink);
              // 释放blob URL地址
              window.URL.revokeObjectURL(blobURL);
            }
          });
        });
      } else if (index === 1) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 1, }, });
      } else if (index === 2) {
        this.$router.push({ path: `/news/details/${data.id}`, query: { type: 2, }, });
      }
    },
    moreEnterprise () {
      this.$router.push({ name: 'CustomerCase', });
    },
    changeStep(i) {
      this.introductionIndex = i.index;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.strategy-organize{
  background-color: #fff;
  .page-content{
    width: 100%;
    .page-canvas{
        width: 100%;
        height: fit-content;
        min-width: var(--minwidth);
        position: relative;
        background-size: cover;
        overflow: hidden;
        .page-background{
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          background-position: top;
          background-size: cover;
          background-repeat: no-repeat;
          // width: 100%;
          // height: 560px;
          // display: flex;
          // justify-content: center;
          // align-items: center;
          // object-fit: cover;
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center top;
          }
        }
        .por-container {
          width: 85%;
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          .solution-info {
            width: 540px;
            height: 560px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            box-sizing: border-box;
            .solution-info-title {
              font-size: 45px;
              font-weight: bold;
              line-height: 55px;
              color: #181818;
              margin-bottom: 30px;
            }
            .solution-info-content {
              font-size: 20px;
              line-height: 32px;
              color: #7b7b7b;
              margin-bottom: 44px;
            }
            .solution-btn {
              width: 142px;
              height: 48px;
              background-color: #00b0dc;
              color: #fff;
              text-align: center;
              line-height: 48px;
              cursor: pointer;
              border-radius: 24px;
            }
          }
        }
    }
    .page-nav{
          width: 100%;
          display: flex;
          position: relative;
          justify-content: center;
          z-index: 50;
          .page-tabs{
              margin: 0 auto;
              box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
              border-radius: 2px;
              background-color: #fff;
              display: flex;
              position: absolute;
              top: -26px;
              .page-nav-item{
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #181818;
              font-size: 14px;
              cursor: pointer;
              }
              .page-nav-item:hover{
              color: #00b0dc;
              }
              .top-nav-item {
              color: #fff;
              background-color: #00b0dc;
              }
              .top-nav-item:hover {
              color: #fff;
              }
          }
    }
    .product-value{
      width: 1200px;
      padding-top: 119px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .flow-chart-content{
        width: 100%;
        img{
          display: block;
          width: 100%;
        }
      }
    }
    .architecture{
      width: 1200px;
      padding-top: 119px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        margin-bottom: 70px;
      }
      .flow-chart-content{
        width: 100%;
        img{
          display: block;
          width: 100%;
        }
      }
    }
    .introduction{
      width: 100%;
      padding-top: 109px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .title{
        font-size: 32px;
        color: #181818;
        line-height: 1;
        padding-bottom: 70px;
        box-sizing: border-box;
      }
      .introduction-tag-list{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        .tag-list-item{
          flex: 1;
          display: flex;
          justify-content: center;
          .tag-list-text{
            font-size: 20px;
            color: #181818;
            line-height: 63px;
            cursor: pointer;
            border-bottom: 6px solid transparent;
          }
          .tag-list-text:hover{
            font-weight: 600;
            border-bottom: 6px solid #00b0dc;
          }
        }
        .tag-list-item-change{
          .tag-list-text{
            font-weight: 600;
            border-bottom: 6px solid #00b0dc;
          }
        }
      }
      .introduction-content-box{
        width: 100%;
        // background-color: #f8fbff;
        padding: 80px 0 60px;
        .introduction-content{
          width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          .introduction-content-left{
            width: 450px;
            padding-top: 41px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            box-sizing: border-box;
            .content-title-wrap{
              display: flex;
              align-items: center;
              justify-content: flex-start;
              margin-bottom: 14px;
              .list{
                width: 6px;
                height: 30px;
                border-radius: 3px;
                background-color: #00b0dc;
              }
              .content-title{
                margin-left: 10px;
                font-size: 32px;
                font-weight: 600;
                line-height: 1;
                color: #181818;
              }
            }
            .content-describe{
              margin-left: 18px;
              font-size: 16px;
              color: #7b7b7b;
              margin-bottom: 15px;
            }
            .content-text-box{
              display: flex;
              align-items: flex-start;
              justify-content: flex-start;
              margin-top: 33px;
              .content-icon{
                width: 24px;
                height: 16px;
                display: block;
                margin-top: 4px;
                margin-right: 8px;
              }
              .content-text{
                font-size: 16px;
                line-height: 25px;
                color: #314666;
              }
            }
          }
          .introduction-content-right{
            width: 740px;
            height: 460px;
            img{
              width: 100%;
              height: auto;
              display: block;
            }
          }
        }
      }
    }
    .data-download-wrap{
      min-width: 1200px;
      background: url('@/assets/strategy/data-back.png') no-repeat;
      background-position: center;
      .data-download{
        width: 70%;
        min-width: 1209px;
        padding-top: 70px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 60px;
        .title{
          font-size: 32px;
          color: #181818;
        }
        .data-download-content{
          display: flex;
          margin: 70px auto 0;
          .data-download-content-item{
            width: 386px;
            height: 250px;
            margin-right: 24px;
            padding: 51px 31px 0 31px;
            background-color: #fff;
            box-sizing: border-box;
            .dataListTitle{
              font-size: 18px;
              color: #181818;
              line-height: 1;
              margin-bottom: 31px;
            }
            .data-list{
              width: 100%;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              .data-list-item{
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-top: 14px;
                // padding-left: 24px;
                box-sizing: border-box;
                list-style:disc;
                .data-list-left{
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  .data-title{
                    width: 254px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 14px;
                    color: #181818;
                    cursor: pointer;
                    position: relative;
                  }
                }
                .data-list-right{
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  img{
                    width: auto;
                    height: 10px;
                    display: block;
                  }
                  display: none;
                }
              }
              .data-list-item:hover{
                .data-list-left{
                  .data-title{
                    color: #00b0dc;
                  }
                }
                .data-list-right{
                  display: block;
                }
              }
            }
          }
          .data-download-content-item:hover{
            background: url('@/assets/strategy/data-item-back.png') no-repeat;
          }
          .data-download-content-item:last-child{
            margin-right: 0;
          }
        }
      }
    }
    .customer-stories{
      width: 100%;
      min-width: 1200px;
      display: flex;
      flex-direction: column;
      background: url('@/assets/staffmanage/customer-back.png') no-repeat;
      background-position: center;
      background-size: cover;
      background-position: center;
      height: 561px;
      padding: 69px 0 60px;
      box-sizing: border-box;
      .customer-stories-content{
        width: 80%;
        min-width: var(--minwidth);
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 32px;
          font-weight: 500;
          color: #181818;
          margin-bottom: 70px;
        }
        .customer-stories-list{
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          .cystiner-stirues-item{
            width: calc(16.666% - 20px);
            height: 70px;
            margin: 10px;
            background-color: #fff;
            border: solid 1px #dfdfdf;
            display: flex;
            box-sizing: border-box;
            justify-content: center;
            align-items: center;
            padding: 10px;
            img{
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }
          }
        }
        .customer-stories-btn{
          width: 155px;
          height: 50px;
          background-color: #00b0dc;
          border-radius: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 20px;
          cursor: pointer;
          .btn-text{
            font-size: 15px;
            color: #ffffff;
          }
          &:hover{
            transform: scale(1.1);
            transition: all  0.5s;
          }
        }
      }
    }
    .data-security{
      padding-top: 60px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .data-security-wrap{
        width: 100%;
        min-width: 1200px;
        height: 330px;
        background: url('@/assets/strategy/security-back.png') no-repeat;
        background-position: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding-top: 55px;
        box-sizing: border-box;
        .data-security-title{
          font-size: 32px;
          color: #181818;
          line-height: 1;
          margin-bottom: 25px;
        }
        .data-security-subtitle{
          font-size: 14px;
          color: #181818;
          line-height: 1;
          margin-bottom: 25px;
        }
        .data-security-btn{
          width: 124px;
          height: 42px;
          background-color: #00b0dc;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .btn-text{
            font-size: 14px;
            color: #fff;
          }
        }
      }
      .data-security-list{
        width: 1200px;
        height: 280px;
        margin: 0 auto;
        background-color: #fff;
        box-shadow: 0px 4px 16px 0px rgba(171, 168, 168, 0.26);
        border-radius: 12px;
        transform: translateY(-92px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 38px;
        box-sizing: border-box;
        .data-security-item{
          width: 365px;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          padding-top: 50px;
          box-sizing: border-box;
          .item-icon-wrap{
            width: 36px;
            img{
              width: 100%;
              height: auto;
              display: block;
            }
          }
          .item-content-wrap{
            flex: 1;
            margin-left: 15px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            .item-content-title{
              margin-top: 5px;
              margin-bottom: 18px;
              font-size: 20px;
              color: #181818;
            }
            .item-content-text{
              margin-top: 10px;
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .textItem-li{
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: #00b0dc;
                margin-right: 10px;
                margin-top: 8px;
              }
              .textItem{
                flex: 1;
                font-size: 16px;
                color: #6d717c;
                line-height: 24px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
